import { render, staticRenderFns } from "./ActivityReview.vue?vue&type=template&id=2439725f&scoped=true"
import script from "./ActivityReview.vue?vue&type=script&lang=js"
export * from "./ActivityReview.vue?vue&type=script&lang=js"
import style0 from "./ActivityReview.vue?vue&type=style&index=0&id=2439725f&prod&lang=scss&scoped=true"
import style1 from "./ActivityReview.vue?vue&type=style&index=1&id=2439725f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439725f",
  null
  
)

export default component.exports